webpackJsonp([2],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1eS9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1f7N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1fYg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SnapLine_vue__ = __webpack_require__("1oPz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ffd6dac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SnapLine_vue__ = __webpack_require__("xZUn");
function injectStyle (ssrContext) {
  __webpack_require__("t+vV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ffd6dac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SnapLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ffd6dac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SnapLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1oPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_interact_js__ = __webpack_require__("oIUO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_interact_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_interact_js__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'snap-line',
  props: ['snapLine', 'scrollWrap', 'onLineMoved'],
  data: function data() {
    return {};
  },

  computed: {
    classes: function classes() {
      var classes = 'snap-line ' + (this.snapLine.isVertical ? 'snap-line-x' : 'snap-line-y');
      if (this.snapLine.isSelected) {
        classes += ' selected';
      }
      return classes;
    },
    style: function style() {
      return (this.snapLine.isVertical ? 'left:' : 'top:') + this.snapLine.position + 'px;';
    },
    title: function title() {
      return this.snapLine.position / 100 + '"';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.snapLine.interactable = __WEBPACK_IMPORTED_MODULE_0_interact_js___default()(this.$refs.snapLine).draggable({
      inertia: false,
      restrict: {
        restriction: 'parent',
        endOnly: true,
        elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
      },
      autoScroll: true,
      onmove: function onmove(event) {
        var oldPos = _this.snapLine.position;
        var pos = void 0;
        if (_this.snapLine.isVertical) {
          pos = _this.snapLine.position + event.dx;
          if (_this.scrollWrap) {
            pos += _this.scrollWrap.scrollLeft;
          }
          pos = Math.min(850, pos);
        } else {
          pos = _this.snapLine.position + event.dy;
          if (_this.scrollWrap) {
            pos += _this.scrollWrap.scrollTop;
          }
          pos = Math.min(1100, pos);
        }
        pos = Math.max(0, pos);
        _this.snapLine.position = pos;
        if (typeof _this.onLineMoved === 'function') {
          _this.onLineMoved(_this.snapLine, oldPos);
        }
      },
      onend: function onend(event) {}
    }).on('dragstart', function (event) {});
  }
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3nrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocField_vue__ = __webpack_require__("6Pit");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5034290_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocField_vue__ = __webpack_require__("xqBx");
function injectStyle (ssrContext) {
  __webpack_require__("p67U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5034290"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5034290_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5g1n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocBuilder_vue__ = __webpack_require__("BGdx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9762a942_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocBuilder_vue__ = __webpack_require__("pGjE");
function injectStyle (ssrContext) {
  __webpack_require__("nE/s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9762a942"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocBuilder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9762a942_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocBuilder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Pit":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'doc-field',
  props: ['docField', 'onSelect'],
  data: function data() {
    return {
      name: ''
      // type: '',
      // text: '',
    };
  },

  watch: {},
  computed: {
    style: function style() {
      return 'width:' + parseInt(this.docField.width) + 'px;height:' + parseInt(this.docField.height) + ('px;top:' + this.docField.y + 'px;left:' + this.docField.x + 'px;font-family:') + (this.docField.fontFamily + ';font-size:' + this.docField.fontSize + 'pt;');
    },
    title: function title() {
      return this.docField.name + ' (' + this.docField.x / 100 + '", ' + this.docField.y / 100 + '")';
    }
  },
  methods: {
    onClick: function onClick() {
      if (typeof this.onSelect === 'function') {
        this.onSelect(this.docField);
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  components: {}
});

/***/ }),

/***/ "7TKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_DocFieldType__ = __webpack_require__("xzgH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mobile-app-editor',
  props: ['allDocFields', 'closeEditor', 'name'],
  data: function data() {
    return {
      mobileEditorMaximized: true,
      DocFieldType: __WEBPACK_IMPORTED_MODULE_0__models_DocFieldType__["a" /* default */]
    };
  },

  watch: {},
  computed: {
    style: function style() {
      return 'left: 270px; top: 41px;';
    }
  },
  methods: {

    /*
     *
     */
    toggleMobileEditorMaximized: function toggleMobileEditorMaximized() {
      this.mobileEditorMaximized = !this.mobileEditorMaximized;
    }
  }
});

/***/ }),

/***/ "8zWL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileAppEditor_vue__ = __webpack_require__("7TKO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b6ad58e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileAppEditor_vue__ = __webpack_require__("e26k");
function injectStyle (ssrContext) {
  __webpack_require__("1f7N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b6ad58e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileAppEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b6ad58e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileAppEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BGdx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_interact_js__ = __webpack_require__("oIUO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_interact_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_interact_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__("oAV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_NumberFormat__ = __webpack_require__("IzlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_DateFormat__ = __webpack_require__("e8Kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_FontOption__ = __webpack_require__("Fcb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_DocField__ = __webpack_require__("Hq7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_DocFieldType__ = __webpack_require__("xzgH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pdfjs_dist__ = __webpack_require__("nKpR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pdfjs_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pdfjs_dist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DocField__ = __webpack_require__("3nrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_MobileAppEditor__ = __webpack_require__("8zWL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DocFieldEditor__ = __webpack_require__("cSz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SnapLine__ = __webpack_require__("1fYg");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var $ = __webpack_require__("7t+N");














__WEBPACK_IMPORTED_MODULE_10_pdfjs_dist___default.a.PDFJS.workerSrc = './static/pdf.worker.js';

var snapRangeX = 12;
var snapRangeY = 10;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'doc-builder',
  data: function data() {
    return {
      mobileEditorOpen: false,
      showEditor: false,
      enableSnap: true,
      previewImageSrc: '',
      name: 'Doc template 1',
      allDocFields: [],
      pages: [{
        pageNo: 1,
        docFields: []
      }],
      pdfDoc: {
        numPages: 1
      },
      selectedPage: {
        pageNo: 1,
        docFields: []
      },
      selectedDocField: {
        name: '',
        isSelected: false
      },
      snapLinesX: [],
      snapLinesY: [],
      sharedDocFieldProps: {
        text: getDefaultSharedProps(),
        number: getDefaultSharedProps(),
        date: getDefaultSharedProps(),
        phone: getDefaultSharedProps(),
        signature: getDefaultSharedProps(),
        check: getDefaultSharedProps('check'),
        checkx: getDefaultSharedProps('checkx'),
        checksq: getDefaultSharedProps('checksq')
      },
      toolInteractable: null,
      dropzoneInteractable: null,
      toolboxInteractable: null,
      DateFormat: __WEBPACK_IMPORTED_MODULE_6__models_DateFormat__["a" /* default */],
      NumberFormat: __WEBPACK_IMPORTED_MODULE_5__models_NumberFormat__["a" /* default */],
      FontOption: __WEBPACK_IMPORTED_MODULE_7__models_FontOption__["a" /* default */],
      DocFieldType: __WEBPACK_IMPORTED_MODULE_9__models_DocFieldType__["a" /* default */]
    };
  },

  components: {
    DocFieldComponent: __WEBPACK_IMPORTED_MODULE_11__components_DocField__["a" /* default */],
    SnapLine: __WEBPACK_IMPORTED_MODULE_14__components_SnapLine__["a" /* default */],
    MobileAppEditor: __WEBPACK_IMPORTED_MODULE_12__components_MobileAppEditor__["a" /* default */],
    DocFieldEditor: __WEBPACK_IMPORTED_MODULE_13__components_DocFieldEditor__["a" /* default */]
  },
  computed: {
    canSave: function canSave() {
      return false;
    }
  },
  watch: {},
  methods: {

    /*
     * Saves the document
     */
    saveDocument: function saveDocument() {},

    /*
     * Converts the selected PDF template file to .png and renders it on the design surface
     */
    uploadFormSubmit: function uploadFormSubmit(e) {
      var _this = this;

      e.preventDefault();
      var fileInput = $(this.$refs.fileUploadInput);
      var fileType = this.$refs.fileUploadInput.files[0].type;
      if (fileType === 'application/pdf') {
        // let pdfUrl = URL.createObjectURL(fileInput.get(0).files[0])
        __WEBPACK_IMPORTED_MODULE_10_pdfjs_dist___default.a.getDocument({ url: URL.createObjectURL(fileInput.get(0).files[0]) }).then(function (pdfDoc) {
          _this.pdfDoc = pdfDoc;
          var pageCt = pdfDoc.numPages;
          _this.pages = [];
          for (var pNo = 1; pNo <= pageCt; pNo++) {
            _this.pages.push({
              pageNo: pNo,
              docFields: []
            });
          }
          if (_this.pages.length > 0) {
            var docFields = _this.selectedPage.docFields;
            _this.selectPage(_this.pages[0]);
            _this.selectedPage.docFields = docFields;
          } else {
            _this.pages.push(_this.selectedPage);
          }
          // pdfDoc.getPage(1).then((page) => {
          //   let canvas = this.$refs.docBuilderCanvas
          //   let scale = canvas.width / page.getViewport(1).width
          //   let viewport = page.getViewport(scale)
          //   canvas.height = viewport.height

          //   let renderContext = {
          //     canvasContext: canvas.getContext('2d'),
          //     viewport: viewport
          //   }
          //   page.render(renderContext).then(() => {
          //     $(canvas).show()
          //   })
          // })
        }).catch(function (err) {
          console.error(err);
        });
      }
      // $.ajax({
      //   url: '/api/useruploads/',
      //   type: 'POST',
      //   data: new FormData(this.$refs.uploadForm),
      //   cache: false,
      //   contentType: false,
      //   processData: false,
      //   success: (data) => {
      //     this.previewImageSrc = 'data:image/png;base64, ' + data
      //     this.showEditor = true
      //   }
      // })
    },

    /*
     * Selects the previous page
     */
    prevPage: function prevPage() {
      if (this.selectedPage.pageNo > 1) {
        this.selectPage(this.selectedPage.pageNo - 2);
      }
    },

    /*
     * Selects the next page
     */
    nextPage: function nextPage() {
      if (this.selectedPage.pageNo <= this.pages.length) {
        this.selectPage(this.selectedPage.pageNo);
      }
    },

    /*
     * Selects a page
     */
    selectPage: function selectPage(selectedPage) {
      var _this2 = this;

      if (typeof selectedPage === 'number' && this.pages.length > selectedPage) {
        this.selectedPage = this.pages[selectedPage];
      } else {
        this.selectedPage = selectedPage;
      }
      if (this.pdfDoc) {
        this.pdfDoc.getPage(this.selectedPage.pageNo).then(function (page) {
          var canvas = _this2.$refs.docBuilderCanvas;
          var scale = canvas.width / page.getViewport(1).width;
          var viewport = page.getViewport(scale);
          canvas.height = viewport.height;

          var renderContext = {
            canvasContext: canvas.getContext('2d'),
            viewport: viewport
          };

          page.render(renderContext).then(function () {
            $(canvas).show();
          });
        });
      }
    },

    /*
     * Converts a toolbox tool element to a doc field component and adds it to the document
     */
    addDocField: function addDocField(toolboxTool) {
      var _this3 = this;

      var toolPos = __WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* default */].getPositioning(toolboxTool, this.$refs.docBuilderSurface, this.$refs.docBuilderSurface);
      var type = toolboxTool.getAttribute('data-field-type');
      var sharedProps = this.sharedDocFieldProps[type];
      sharedProps.count++;

      var docField = new __WEBPACK_IMPORTED_MODULE_8__models_DocField__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        type: type,
        height: toolboxTool.offsetHeight,
        isSelected: true,
        isRequired: sharedProps.isRequired,
        onSelect: this.onSelect
      }, this.getSnapLines(toolPos.left, toolPos.top)), sharedProps);

      this.onSelectDocField(docField);
      this.selectedPage.docFields.push(docField);
      this.allDocFields.push(docField);

      docField.interactable = __WEBPACK_IMPORTED_MODULE_3_interact_js___default()('#_' + docField.uuid).draggable({
        inertia: false,
        restrict: {
          restriction: 'parent',
          endOnly: true,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        autoScroll: true,
        onmove: function onmove(event) {
          var target = event.target;
          var x = docField.x + event.dx;
          var y = docField.y + event.dy;
          target.style.left = x + 'px';
          target.style.top = y + 'px';
          docField.x = x;
          docField.y = y;
          _this3.checkSnapLines(x, y);
        },
        onend: function onend(event) {
          var target = event.target;
          var snap = _this3.getSnapLines(docField.x, docField.y);
          target.style.left = snap.x + 'px';
          target.style.top = snap.y + 'px';
          docField.x = snap.x;
          docField.y = snap.y;
          docField.snapLineX = snap.snapLineX;
          docField.snapLineY = snap.snapLineY;
        }
      }).on('dragstart', function (event) {
        _this3.snapLinesX.forEach(function (sn) {
          sn.isSelected = false;
        });

        _this3.snapLinesY.forEach(function (sn) {
          sn.isSelected = false;
        });
        if (typeof _this3.onSelect === 'function') {
          _this3.onSelect(docField);
        }
      }).resizable({
        edges: { right: true }
      }).on('resizemove', function (event) {
        var target = event.target;
        if (typeof _this3.onSelect === 'function') {
          _this3.onSelect(docField);
        }
        target.style.height = event.rect.height + 'px';
        target.style.width = event.rect.width + 'px';
        docField.height = event.rect.height;
        docField.width = event.rect.width;

        var type = docField.type;
        _this3.sharedDocFieldProps[type].height = docField.height;
        _this3.sharedDocFieldProps[type].width = docField.width;
      });

      // console.log(JSON.stringify(this.allDocFields.map(df => {
      //   return df.getCleanedJson()
      // }), null, '  '))
    },

    /*
     * Checks snap lines
     */
    getSnapLines: function getSnapLines(left, top) {
      var xy = void 0;
      var snapX = this.snapLinesX.find(function (line) {
        return Math.abs(line.position - left) <= snapRangeX;
      });
      var snapY = this.snapLinesY.find(function (line) {
        return Math.abs(line.position - top) <= snapRangeY;
      });

      if (!snapX) {
        snapX = {
          isSelected: true,
          uuid: __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default()(),
          isVertical: true,
          position: left
        };
        this.snapLinesX.push(snapX);
      }

      if (!snapY) {
        snapY = {
          uuid: __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default()(),
          isSelected: true,
          isVertical: false,
          position: top
        };
        this.snapLinesY.push(snapY);
      }

      if (this.enableSnap) {
        xy = {
          snapLineX: snapX,
          snapLineY: snapY,
          x: snapX ? snapX.position : left,
          y: snapY ? snapY.position : top
        };
      } else {
        xy = {
          snapLineX: this.snapLinesX.find(function (sn) {
            return sn.position === left;
          }), // snapX,
          snapLineY: this.snapLinesY.find(function (sn) {
            return sn.position === top;
          }), // snapY,
          x: left,
          y: top
        };
      }

      return xy;
    },

    /*
     *
     */
    checkSnapLines: function checkSnapLines(x, y) {
      this.snapLinesX.forEach(function (sn) {
        sn.isSelected = false;
      });

      this.snapLinesY.forEach(function (sn) {
        sn.isSelected = false;
      });

      var snapX = this.snapLinesX.find(function (sn) {
        return Math.abs(sn.position - x) <= snapRangeX;
      });
      var snapY = this.snapLinesY.find(function (sn) {
        return Math.abs(sn.position - y) <= snapRangeY;
      });
      if (snapX) {
        snapX.isSelected = true;
      }
      if (snapY) {
        snapY.isSelected = true;
      }
    },

    /*
     *
     */
    onSnapLineMoved: function onSnapLineMoved(snapLine, oldPos) {
      if (snapLine.isVertical) {
        this.selectedPage.docFields.forEach(function (df) {
          if (snapLine.position >= df.x && oldPos <= df.x || snapLine.position <= df.x && oldPos >= df.x) {
            df.x = snapLine.position;
          }
          // if (Math.abs(snapLine.position - df.x) <= snapRangeX) {
          //   df.x = snapLine.position
          // }
        });
      } else {
        this.selectedPage.docFields.forEach(function (df) {
          if (snapLine.position >= df.y && oldPos <= df.y || snapLine.position <= df.y && oldPos >= df.y) {
            df.y = snapLine.position;
          }
          // if (Math.abs(snapLine.position - df.y) <= snapRangeY) {
          //   df.y = snapLine.position
          // }
        });
      }
    },

    /*
     * Selected number or date format changed
     */
    onFormatChanged: function onFormatChanged() {
      this.selectedDocField.updateText();
      var sharedProps = this.sharedDocFieldProps[this.selectedDocField.type];
      if (this.selectedDocField.type === 'number') {
        sharedProps.numberFormat = this.selectedDocField.numberFormat;
      } else if (this.selectedDocField.type === 'date') {
        sharedProps.dateFormat = this.selectedDocField.dateFormat;
      }
    },

    /*
     * Selected doc field font changed
     */
    onFontChanged: function onFontChanged() {
      var _arr = ['text', 'number', 'phone', 'date'];

      for (var _i = 0; _i < _arr.length; _i++) {
        var type = _arr[_i];
        var sharedProps = this.sharedDocFieldProps[type];
        sharedProps.fontFamily = this.selectedDocField.fontFamily;
        sharedProps.fontSize = this.selectedDocField.fontSize;
      }
    },

    /*
     * Updates the current doc field selection and loads its properties
     */
    onSelectDocField: function onSelectDocField(docField) {
      this.snapLinesX.forEach(function (sn) {
        sn.isSelected = false;
      });

      this.snapLinesY.forEach(function (sn) {
        sn.isSelected = false;
      });

      this.selectedPage.docFields.forEach(function (df) {
        df.isSelected = df.uuid === docField.uuid;
      });

      this.selectedDocField = docField || {
        name: '',
        isSelected: false
      };

      if (this.selectedDocField.snapLineX) {
        this.selectedDocField.snapLineX.isSelected = true;
      }

      if (this.selectedDocField.snapLineY) {
        this.selectedDocField.snapLineY.isSelected = true;
      }

      // this.$nextTick(() => this.$refs.selectedDocFieldName.select())
    },

    /*
     * Deletes a doc field at the given index
     */
    onDeleteDocField: function onDeleteDocField(docField, index) {
      this.selectedPage.docFields.splice(index, 1);
      this.allDocFields = this.allDocFields.filter(function (df) {
        return df.uuid !== docField.uuid;
      });
      if (this.selectedDocField.uuid === docField.uuid) {
        this.selectedDocField.isSelected = false;
        this.selectedDocField = {
          name: '',
          isSelected: false
        };
      }
    },

    /*
     * Moves the selected doc field up 1 pixel
     */
    moveDocFieldUp: function moveDocFieldUp() {
      this.selectedDocField.moveY(-1, this.snapLinesY);
    },

    /*
     * Moves the selected doc field down 1 pixel
     */
    moveDocFieldDown: function moveDocFieldDown() {
      this.selectedDocField.moveY(1, this.snapLinesY);
    },

    /*
     * Moves the selected doc field left 1 pixel
     */
    moveDocFieldLeft: function moveDocFieldLeft() {
      this.selectedDocField.moveX(-1, this.snapLinesX);
    },

    /*
     * Moves the selected doc field right 1 pixel
     */
    moveDocFieldRight: function moveDocFieldRight() {
      this.selectedDocField.moveX(1, this.snapLinesX);
    },

    /*
     *
     */
    toggleMobileEditorOpen: function toggleMobileEditorOpen(isOpen) {
      if (typeof isOpen === 'boolean') {
        this.mobileEditorOpen = isOpen;
      } else {
        this.mobileEditorOpen = !this.mobileEditorOpen;
      }
    },

    /*
     *
     */
    closeMobileEditor: function closeMobileEditor() {
      this.toggleMobileEditorOpen(false);
    }
  },

  /**
   * Set up draggable elements when the component is mounted
   */
  mounted: function mounted() {
    var _this4 = this;

    var surfaceOffset = __WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* default */].getPositioning(this.$refs.docBuilder, this.$refs.docBuilder, this.$refs.docBuilderSurface);

    // set up ability to drag toolbox tools onto the doc builder surface
    var draggingTool = void 0;
    this.toolInteractable = __WEBPACK_IMPORTED_MODULE_3_interact_js___default()('.toolbox-tool').draggable({
      inertia: false,
      restrict: {
        restriction: this.$refs.docBuilder,
        endOnly: true,
        elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
      },
      autoScroll: true,
      onmove: function onmove(event) {
        if (draggingTool) {
          var x = (parseFloat(draggingTool.getAttribute('data-x')) || 0) + event.dx;
          var y = (parseFloat(draggingTool.getAttribute('data-y')) || 0) + event.dy;
          draggingTool.style.top = y + 'px';
          draggingTool.style.left = x + 'px';
          draggingTool.setAttribute('data-x', x);
          draggingTool.setAttribute('data-y', y);
          _this4.checkSnapLines(x - Math.abs(surfaceOffset.left), y - Math.abs(surfaceOffset.top));
        }
      },
      onend: function onend(event) {
        _this4.addDocField(draggingTool);
        _this4.$refs.docBuilder.removeChild(draggingTool);
      }
    }).on('dragstart', function (event) {
      _this4.snapLinesX.forEach(function (sn) {
        sn.isSelected = false;
      });

      _this4.snapLinesY.forEach(function (sn) {
        sn.isSelected = false;
      });

      var target = event.target;
      if (!target.dragOrigin) {
        draggingTool = target.cloneNode(true);
        var targetOffset = __WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* default */].getPositioning(target, _this4.$refs.docBuilder, _this4.$refs.docBuilder);
        var fieldType = draggingTool.getAttribute('data-field-type');
        draggingTool.classList.add('dragging');
        draggingTool.style.position = 'absolute';
        draggingTool.style.top = targetOffset.top + 'px';
        draggingTool.style.left = targetOffset.left + 'px';
        draggingTool.style.width = target.getBoundingClientRect().width + 'px';
        draggingTool.dragOrigin = target;

        if (fieldType !== 'check' && fieldType !== 'checkx' && fieldType !== 'checksq') {
          draggingTool.innerHTML = __WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* default */].getDefaultDocFieldText(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            type: fieldType
          }, getDefaultSharedProps()));
        } else {
          var icon = document.createElement('i');
          var iconClass = void 0;
          switch (fieldType) {
            case 'check':
              iconClass = 'fa-check';
              break;
            case 'checkx':
              iconClass = 'fa-close';
              break;
            case 'checksq':
              iconClass = 'fa-square';
              break;
          }
          icon.classList.add('fa', iconClass);
          draggingTool.innerHTML = '';
          draggingTool.appendChild(icon);
        }

        _this4.$refs.docBuilder.appendChild(draggingTool);
        draggingTool.setAttribute('data-x', targetOffset.left);
        draggingTool.setAttribute('data-y', targetOffset.top);
        event.interaction.element = draggingTool;
        event.interaction.draggingTool = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(document.querySelectorAll('.selected')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var tool = _step.value;

            tool.classList.remove('selected');
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        draggingTool = target;
      }
    });

    // make the doc builder surface a dropzone
    this.dropzoneInteractable = __WEBPACK_IMPORTED_MODULE_3_interact_js___default()(this.$refs.docBuilderSurface).dropzone({
      accept: '.toolbox-tool',
      overlap: 0.75,
      ondropactivate: function ondropactivate(event) {},
      ondragenter: function ondragenter(event) {
        if (draggingTool) {
          draggingTool.classList.add('active');
          draggingTool.classList.add('selected');
        }
      },
      ondragleave: function ondragleave(event) {
        if (draggingTool) {
          draggingTool.classList.remove('active');
          draggingTool.classList.remove('selected');
        }
      },
      ondrop: function ondrop(event) {},
      ondropdeactivate: function ondropdeactivate(event) {}
    });

    // make the toolbox draggable
    this.toolboxInteractable = __WEBPACK_IMPORTED_MODULE_3_interact_js___default()('.toolbox-hdr').draggable({
      inertia: false,
      restrict: {
        restriction: this.$refs.docBuilder,
        endOnly: true,
        elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
      },
      autoScroll: true,
      onmove: function onmove(event) {
        var target = event.target.parentNode;
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
      }
    });
  },

  /**
   * Unset draggable elements before the component is destroyed
   */
  beforeDestroy: function beforeDestroy() {
    this.selectedPage.docFields.map(function (docField) {
      return docField.interactable;
    }).forEach(function (interactable) {
      __WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* default */].unsetInteractable(interactable);
    });
    // this.snapLinesX.map(snapLine => { return snapLine.interactable }).forEach(interactable => {
    //   utils.unsetInteractable(interactable)
    // })
    // this.snapLinesY.map(snapLine => { return snapLine.interactable }).forEach(interactable => {
    //   utils.unsetInteractable(interactable)
    // })

    __WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* default */].unsetInteractable(this.toolInteractable);
    __WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* default */].unsetInteractable(this.dropzoneInteractable);
    __WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* default */].unsetInteractable(this.toolboxInteractable);
  }

  /**
   *
   */
});var getDefaultSharedProps = function getDefaultSharedProps(type) {
  var width = void 0;
  switch (type) {
    case 'check':
    case 'checkx':
    case 'checksq':
      width = 44;
      break;
    default:
      width = 188;
      break;
  }
  return {
    count: 0,
    width: width,
    height: 0,
    fontFamily: __WEBPACK_IMPORTED_MODULE_7__models_FontOption__["a" /* default */].helvetica,
    fontSize: 12,
    isRequired: false,
    numberFormat: __WEBPACK_IMPORTED_MODULE_5__models_NumberFormat__["a" /* default */].none,
    dateFormat: __WEBPACK_IMPORTED_MODULE_6__models_DateFormat__["a" /* default */].MMddyyyySlash
  };
};

/***/ }),

/***/ "FQpU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documents_vue__ = __webpack_require__("UF7x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da953b9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documents_vue__ = __webpack_require__("nS5c");
function injectStyle (ssrContext) {
  __webpack_require__("r1n9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da953b9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da953b9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fcb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  helvetica: 'Helvetica',
  times: 'Times',
  courier: 'Courier'
}));

/***/ }),

/***/ "Hq7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xdate__ = __webpack_require__("sFe/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_xdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__("oAV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__ = __webpack_require__("xzgH");










/**
 *
 */

var _class = function () {

  /**
   *
   */
  function _class(opts, sharedProps) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.uuid = __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()();
    this.type = opts.type;
    this.x = opts.x;
    this.y = opts.y;
    this.height = opts.height;
    this.isSelected = opts.isSelected === true;
    this.isRequired = opts.isRequired === true;
    this.snapLineX = opts.snapLineX;
    this.snapLineY = opts.snapLineY;
    this.text = opts.text;

    if (typeof opts.name !== 'string' || opts.name.length === 0) {
      this.name = __WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* default */].capitalizeWord(this.type) + ' Field ' + sharedProps.count;
    } else {
      this.name = opts.name;
    }

    if ((typeof sharedProps === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sharedProps)) === 'object') {
      this.fontSize = opts.fontSize || sharedProps.fontSize;
      this.fontFamily = opts.fontFamily || sharedProps.fontFamily;
      this.numberFormat = opts.numberFormat || sharedProps.numberFormat;
      this.dateFormat = opts.dateFormat || sharedProps.dateFormat;
      this.width = opts.width || sharedProps.width;
    }
    this.updateText();
  }

  /**
   *
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'getCleanedJson',
    value: function getCleanedJson() {
      return {
        uuid: this.uuid,
        name: this.name,
        type: this.type,
        x: this.x,
        y: this.y,
        height: this.height,
        isRequired: this.isRequired,
        fontSize: this.fontSize,
        fontFamily: this.fontFamily,
        numberFormat: this.numberFormat,
        dateFormat: this.dateFormat,
        width: this.width
      };
    }

    /**
     *
     */

  }, {
    key: 'updateText',
    value: function updateText() {
      switch (this.type) {
        case __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__["a" /* default */].text:
          this.text = 'Example text';
          break;
        case __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__["a" /* default */].number:
          var num = 12345.67;
          this.text = this.numberFormat ? __WEBPACK_IMPORTED_MODULE_3_numeral___default()(num).format(this.numberFormat) : num;
          break;
        case __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__["a" /* default */].date:
          var dateStr = new __WEBPACK_IMPORTED_MODULE_5_xdate___default.a(2017, 0, 1).toString(this.dateFormat);
          this.text = dateStr;
          break;
        case __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__["a" /* default */].phone:
          this.text = '555-555-1234';
          break;
        case __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__["a" /* default */].signature:
          this.text = 'Signature';
          break;
        case __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__["a" /* default */].check:
        case __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__["a" /* default */].checkx:
        case __WEBPACK_IMPORTED_MODULE_7__models_DocFieldType__["a" /* default */].checksq:
          this.text = ' ';
          break;
      }
    }

    /**
     *
     */

  }, {
    key: 'moveY',
    value: function moveY(px, snapLines) {
      var _this = this;

      var newY = this.y + px;
      if (newY >= 0 && newY + this.height <= 1100) {
        this.y = newY;
        if (this.snapLineY) {
          this.snapLineY.isSelected = false;
        }

        var snapLineY = snapLines.find(function (sn) {
          return sn.position === _this.y;
        });

        this.snapLineY = snapLineY;

        if (this.snapLineY) {
          this.snapLineY.isSelected = true;
        }
      }
    }

    /**
     *
     */

  }, {
    key: 'moveX',
    value: function moveX(px, snapLines) {
      var _this2 = this;

      var newX = this.x + px;
      if (newX >= 0 && newX < 830) {
        this.x = newX;
        if (this.snapLineX) {
          this.snapLineX.isSelected = false;
        }

        var snapLineX = snapLines.find(function (sn) {
          return sn.position === _this2.x;
        });

        this.snapLineX = snapLineX;

        if (this.snapLineX) {
          this.snapLineX.isSelected = true;
        }
      }
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ "IzlZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  none: '',
  comma: '0,0',
  currency: '$0,0.00'
}));

/***/ }),

/***/ "Ja1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-nav",class:_vm.isNavMaximized ? 'app-nav-maximized' : ''},[_c('div',{staticClass:"app-nav-toggle",on:{"click":_vm.toggleNav}},[_c('i',{staticClass:"fa fa-thumb-tack"})]),_vm._v(" "),_c('router-link',{attrs:{"to":"/Documents","title":"Manage to your documents"}},[_c('i',{staticClass:"fa fa-files-o"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNavMaximized),expression:"isNavMaximized"}]},[_vm._v("Documents")])])],1),_vm._v(" "),_c('div',{staticClass:"app-body",class:_vm.isNavMaximized ? 'app-nav-maximized' : ''},[_c('router-view',{key:_vm.$route.name})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7321154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ja1w");
function injectStyle (ssrContext) {
  __webpack_require__("tGCc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7321154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.reuse === false;
  })) {
    app.key = to.path;
  } else {
    app.key = null;
  }
  next();
});

/***/ }),

/***/ "UF7x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DocBuilder__ = __webpack_require__("5g1n");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'documents',
  data: function data() {
    return {
      docBuilderOpen: true
    };
  },

  watch: {},
  methods: {},
  mounted: function mounted() {},
  components: {
    DocBuilder: __WEBPACK_IMPORTED_MODULE_0__components_DocBuilder__["a" /* default */]
  }
});

/***/ }),

/***/ "UN7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Documents__ = __webpack_require__("FQpU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Account__ = __webpack_require__("uK6g");




// import Dashboard from '@/components/Dashboard'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Documents',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Documents__["a" /* default */]
  }, {
    path: '/documents',
    name: 'Documents',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Documents__["a" /* default */]
  }, {
    path: '/account',
    name: 'Account',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Account__["a" /* default */]
  }]
}));

/***/ }),

/***/ "cSz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocFieldEditor_vue__ = __webpack_require__("tDjX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f08834_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocFieldEditor_vue__ = __webpack_require__("dmG3");
function injectStyle (ssrContext) {
  __webpack_require__("1eS9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88f08834"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocFieldEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f08834_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocFieldEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dmG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDocField.isSelected),expression:"selectedDocField.isSelected"}],staticClass:"doc-field-editor"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"toolbox"},[_c('div',{staticClass:"input-wrap"},[_c('h4',[_vm._v("Field Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocField.name),expression:"selectedDocField.name"}],ref:"selectedDocFieldName",attrs:{"type":"text"},domProps:{"value":(_vm.selectedDocField.name)},on:{"focus":function($event){$event.target.select()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedDocField, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-wrap"},[_c('div',{staticClass:"checkbox-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocField.isRequired),expression:"selectedDocField.isRequired"}],attrs:{"id":"is-required-chk","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedDocField.isRequired)?_vm._i(_vm.selectedDocField.isRequired,null)>-1:(_vm.selectedDocField.isRequired)},on:{"change":function($event){var $$a=_vm.selectedDocField.isRequired,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedDocField.isRequired=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedDocField.isRequired=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.selectedDocField, "isRequired", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"is-required-chk"}},[_vm._v("Required?")])])]),_vm._v(" "),(['text', 'number', 'date'].indexOf(_vm.selectedDocField.type) > -1)?_c('div',{staticClass:"input-wrap"},[_c('h4',[_vm._v("Default Value")]),_vm._v(" "),(_vm.selectedDocField.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocField.defaultVal),expression:"selectedDocField.defaultVal"}],attrs:{"type":"number"},domProps:{"value":(_vm.selectedDocField.defaultVal)},on:{"focus":function($event){$event.target.select()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedDocField, "defaultVal", $event.target.value)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocField.defaultVal),expression:"selectedDocField.defaultVal"}],attrs:{"type":"text"},domProps:{"value":(_vm.selectedDocField.defaultVal)},on:{"focus":function($event){$event.target.select()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedDocField, "defaultVal", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.selectedDocField.type === 'number')?_c('div',{staticClass:"input-wrap"},[_c('h4',[_vm._v("Number Format")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocField.numberFormat),expression:"selectedDocField.numberFormat"}],staticClass:"number-format-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedDocField, "numberFormat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onChangeFormat]}},[_c('option',{domProps:{"value":_vm.NumberFormat.none}},[_vm._v("None")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.NumberFormat.comma}},[_vm._v("Comma")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.NumberFormat.currency}},[_vm._v("Currency")])])]):_vm._e(),_vm._v(" "),(_vm.selectedDocField.type === 'date')?_c('div',{staticClass:"input-wrap"},[_c('h4',[_vm._v("Date Format")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocField.dateFormat),expression:"selectedDocField.dateFormat"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedDocField, "dateFormat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onChangeFormat]}},[_c('option',{domProps:{"value":_vm.DateFormat.MMddyyyySlash}},[_vm._v("MM/dd/yyyy")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.DateFormat.MMddyyyyDash}},[_vm._v("MM-dd-yyyy")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.DateFormat.yyyyMMddSlash}},[_vm._v("yyyy/MM/dd")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.DateFormat.yyyyMMddDash}},[_vm._v("yyyy-MM-dd")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.DateFormat.yyyyMMdd}},[_vm._v("yyyyMMdd")])])]):_vm._e(),_vm._v(" "),(['text', 'number', 'phone', 'date'].indexOf(_vm.selectedDocField.type) > -1)?_c('div',{staticClass:"input-wrap"},[_c('h4',[_vm._v("Font")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocField.fontFamily),expression:"selectedDocField.fontFamily"}],staticClass:"font-select float-left",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedDocField, "fontFamily", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onChangeFont]}},[_c('option',{domProps:{"value":_vm.FontOption.helvetica}},[_vm._v("Helvetica")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.FontOption.courier}},[_vm._v("Courier")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.FontOption.times}},[_vm._v("Times")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocField.fontSize),expression:"selectedDocField.fontSize"}],staticClass:"font-size-select float-left",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedDocField, "fontSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onChangeFont]}},[_c('option',{domProps:{"value":8}},[_vm._v("8pt")]),_vm._v(" "),_c('option',{domProps:{"value":9}},[_vm._v("9pt")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10pt")]),_vm._v(" "),_c('option',{domProps:{"value":11}},[_vm._v("11pt")]),_vm._v(" "),_c('option',{domProps:{"value":12}},[_vm._v("12pt")]),_vm._v(" "),_c('option',{domProps:{"value":13}},[_vm._v("13pt")]),_vm._v(" "),_c('option',{domProps:{"value":14}},[_vm._v("14pt")]),_vm._v(" "),_c('option',{domProps:{"value":15}},[_vm._v("15pt")])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-hdr"},[_c('i',{staticClass:"fa fa-ellipsis-v"}),_c('i',{staticClass:"fa fa-ellipsis-v"}),_vm._v("\n    Field Properties")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e26k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-app-editor",style:(_vm.style)},[_c('div',{staticClass:"toolbox-hdr"},[_c('i',{staticClass:"fa fa-ellipsis-v"}),_c('i',{staticClass:"fa fa-ellipsis-v"}),_vm._v("\n    Mobile App Preview\n    "),_c('div',{staticClass:"toolbox-hdr-btn-wrap"},[_c('button',{staticClass:"btn btn-plain",on:{"click":_vm.toggleMobileEditorMaximized}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileEditorMaximized),expression:"mobileEditorMaximized"}],staticClass:"fa fa-window-minimize"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileEditorMaximized),expression:"!mobileEditorMaximized"}],staticClass:"fa fa-window-maximize"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-plain",on:{"click":_vm.closeEditor}},[_c('i',{staticClass:"fa fa-close"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileEditorMaximized),expression:"mobileEditorMaximized"}],staticClass:"toolbox"},[_c('img',{attrs:{"src":"static/iphone_outline_gray_sm.png"}}),_vm._v(" "),_c('div',{staticClass:"mobile-app-surface-wrap"},[_c('div',{staticClass:"mobile-app-surface"},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_vm._l((_vm.allDocFields),function(item,index){return _c('div',{staticClass:"mobile-app-input-wrap"},[(['check', 'checkx', 'checksq'].indexOf(item.type) === -1)?_c('div',{staticClass:"mobile-app-input-label"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),(item.type === _vm.DocFieldType.text)?_c('input',{staticClass:"w100",attrs:{"type":"text","disabled":""}}):_vm._e(),_vm._v(" "),(item.type === _vm.DocFieldType.signature)?_c('textarea',{staticClass:"w100",attrs:{"rows":"2","disabled":""}}):_vm._e(),_vm._v(" "),(item.type === _vm.DocFieldType.number)?_c('input',{staticClass:"w100",attrs:{"type":"number","disabled":""}}):_vm._e(),_vm._v(" "),(item.type === _vm.DocFieldType.phone)?_c('input',{attrs:{"type":"text","placeholder":"   -   -    ","disabled":""}}):_vm._e(),_vm._v(" "),(item.type === _vm.DocFieldType.date)?_c('input',{attrs:{"type":"text","placeholder":item.text,"disabled":""}}):_vm._e(),_vm._v(" "),(item.type === _vm.DocFieldType.date)?_c('i',{staticClass:"fa fa-calendar"}):_vm._e(),_vm._v(" "),(['check', 'checkx', 'checksq'].indexOf(item.type) > -1)?_c('div',{staticClass:"checkbox-wrap"},[_c('label',{attrs:{"for":'mobile-app-input-chk' + item.uuid}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('input',{attrs:{"id":"'mobile-app-input-chk' + item.uuid","type":"checkbox"}})]):_vm._e()])}),_vm._v(" "),_vm._m(0)],2)]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-app-bottom"},[_c('h4',[_vm._v("Name for this document")]),_vm._v(" "),_c('input',{staticClass:"w100",attrs:{"type":"text","disabled":""}}),_vm._v(" "),_c('div',{staticClass:"mobile-app-btn"},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save this document")]),_vm._v(" "),_c('div',{staticClass:"mobile-app-btn"},[_c('i',{staticClass:"fa fa-envelope-o"}),_vm._v(" Save & email this document")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-app-btns"},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" "),_c('i',{staticClass:"fa fa-list"}),_vm._v(" "),_c('i',{staticClass:"fa fa-cog"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e8Kb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  MMddyyyySlash: 'MM/dd/yyyy',
  MMddyyyyDash: 'MM-dd-yyyy',
  yyyyMMddSlash: 'yyyy/MM/dd',
  yyyyMMddDash: 'yyyy-MM-dd',
  yyyyMMdd: 'yyyyMMdd'
}));

/***/ }),

/***/ "nE/s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nS5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documents"},[(_vm.docBuilderOpen)?_c('doc-builder'):_c('h3',[_vm._v("Documents")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oAV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xdate__ = __webpack_require__("sFe/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xdate__);






var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
    key: 'getPositioning',


    /**
     * Gets the left and top offsets of an element, optionally subtracting a second element's offsets
     */
    value: function getPositioning(el, scrollEl, subtractEl) {
      el = el.getBoundingClientRect();
      var result = {
        left: el.left + window.scrollX,
        top: el.top + window.scrollY,
        width: el.width,
        height: el.height
      };

      if (scrollEl) {
        result.left += scrollEl.scrollLeft;
        result.top += scrollEl.scrollTop;
      }

      if (subtractEl) {
        subtractEl = subtractEl.getBoundingClientRect();
        result.left -= subtractEl.left;
        result.top -= subtractEl.top;
      }
      return result;
    }

    /**
     *
     */

  }, {
    key: 'unsetInteractable',
    value: function unsetInteractable(interactable) {
      if ((typeof interactable === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(interactable)) === 'object' && typeof interactable.unset === 'function') {
        interactable.unset();
      }
    }

    /**
     *
     */

  }, {
    key: 'capitalizeWord',
    value: function capitalizeWord(text) {
      var res = '' + text;
      if (res.length > 0) {
        res = res.substring(0, 1).toUpperCase() + res.substring(1, res.length);
      }
      return res;
    }

    /**
     *
     */

  }, {
    key: 'getDefaultDocFieldText',
    value: function getDefaultDocFieldText(docField) {
      switch (docField.type) {
        case 'text':
          return 'Example text';
        case 'number':
          var num = 12345.67;
          return docField.numberFormat ? __WEBPACK_IMPORTED_MODULE_3_numeral___default()(num).format(docField.numberFormat) : num;
        case 'date':
          var dateStr = new __WEBPACK_IMPORTED_MODULE_4_xdate___default.a(2017, 0, 1).toString(docField.dateFormat);
          return dateStr;
        case 'phone':
          return '555-555-1234';
        case 'signature':
          return 'Signature';
        case 'check':
        case 'checkx':
        case 'checksq':
          return ' ';
      }
      return '';
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ "p67U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pGjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"docBuilder",staticClass:"doc-builder",on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }_vm.moveDocFieldUp($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }_vm.moveDocFieldDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key)){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.moveDocFieldLeft($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39,$event.key)){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.moveDocFieldRight($event)}]}},[_c('div',{staticClass:"settings-wrap"},[_c('div',{staticClass:"panel-wrapper",staticStyle:{"margin-bottom":"4px"}},[_c('label',{staticClass:"settings-label float-left"},[_vm._v("Doc Template Name\n        "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.name),expression:"!name"}],staticClass:"red"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"doc-name-input",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"panel-wrapper"},[_c('label',{staticClass:"settings-label float-left"},[_vm._v("Template File")]),_vm._v(" "),_c('form',{ref:"uploadForm",staticClass:"float-left",attrs:{"action":"/api/useruploads/","method":"POST","enctype":"multipart/form-data"},on:{"submit":_vm.uploadFormSubmit}},[_c('input',{ref:"fileUploadInput",attrs:{"name":"file","type":"file"},on:{"change":_vm.uploadFormSubmit}}),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"settings-btn-wrap"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileEditorOpen),expression:"!mobileEditorOpen"}],staticClass:"btn btn-default",on:{"click":function($event){_vm.toggleMobileEditorOpen(true)}}},[_c('i',{staticClass:"fa fa-mobile"}),_vm._v(" Mobile Preview")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right",attrs:{"disabled":!_vm.canSave},on:{"click":_vm.saveDocument}},[_vm._v("Save "),_c('i',{staticClass:"fa fa-save"})])])]),_vm._v(" "),_c('div',{staticClass:"surface-toolbar"},[_c('div',{staticClass:"use-snap-chk-wrap checkbox-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enableSnap),expression:"enableSnap"}],attrs:{"id":"use-snap-chk","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.enableSnap)?_vm._i(_vm.enableSnap,null)>-1:(_vm.enableSnap)},on:{"change":function($event){var $$a=_vm.enableSnap,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enableSnap=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enableSnap=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enableSnap=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"use-snap-chk"}},[_vm._v("Use Snap Lines")])]),_vm._v(" "),_c('div',{staticClass:"page-nav-wrap"},[_c('button',{staticClass:"btn btn-plain",attrs:{"disabled":_vm.selectedPage.pageNo < 2},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-arrow-left"})]),_vm._v(" "),_c('span',[_vm._v("Page "+_vm._s(_vm.selectedPage.pageNo)+" of "+_vm._s(_vm.pdfDoc.numPages))]),_vm._v(" "),_c('button',{staticClass:"btn btn-plain",attrs:{"disabled":_vm.selectedPage.pageNo === _vm.pdfDoc.numPages},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-arrow-right"})])])]),_vm._v(" "),_c('div',{ref:"docBuilderSurface",staticClass:"doc-builder-surface"},[_vm._l((_vm.snapLinesX),function(item){return _c('snap-line',{directives:[{name:"show",rawName:"v-show",value:(_vm.enableSnap),expression:"enableSnap"}],key:item.uuid,attrs:{"snap-line":item,"scroll-wrap":_vm.$refs.docBuilderSurface,"on-line-moved":_vm.onSnapLineMoved}})}),_vm._v(" "),_vm._l((_vm.snapLinesY),function(item){return _c('snap-line',{directives:[{name:"show",rawName:"v-show",value:(_vm.enableSnap),expression:"enableSnap"}],key:item.uuid,attrs:{"snap-line":item,"scroll-wrap":_vm.$refs.docBuilderSurface,"on-line-moved":_vm.onSnapLineMoved}})}),_vm._v(" "),_vm._l((_vm.selectedPage.docFields),function(item,index){return _c('doc-field-component',{key:item.uuid,attrs:{"doc-field":item,"on-select":_vm.onSelectDocField,"id":'_' + item.uuid},on:{"delete-doc-field":function($event){_vm.onDeleteDocField(item, index)}}})}),_vm._v(" "),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditor),expression:"showEditor"}],ref:"docBuilderCanvas",staticClass:"doc-builder-img",attrs:{"height":"1100","width":"850"}}),_vm._v(" "),_c('div',{staticClass:"toolbox-tool-wrap toolbox-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{ref:"toolbox",staticClass:"toolbox"},[_c('div',{staticClass:"toolbox-tool",attrs:{"data-field-type":"text"}},[_vm._v("Text")]),_vm._v(" "),_c('div',{staticClass:"toolbox-tool",attrs:{"data-field-type":"number"}},[_vm._v("Number")]),_vm._v(" "),_c('div',{staticClass:"toolbox-tool",attrs:{"data-field-type":"date"}},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"toolbox-tool",attrs:{"data-field-type":"phone"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('div',{staticClass:"toolbox-tool",attrs:{"data-field-type":"signature"}},[_vm._v("Signature")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","clear":"both","margin-bottom":"4px"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"float-left"},[_vm._v(" Checkbox")])])]),_vm._v(" "),_c('doc-field-editor',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDocField.isSelected),expression:"selectedDocField.isSelected"}],attrs:{"selected-doc-field":_vm.selectedDocField,"drag-restriction":_vm.$refs.docBuilder,"on-format-changed":_vm.onFormatChanged,"on-font-changed":_vm.onFontChanged}})],2),_vm._v(" "),(_vm.mobileEditorOpen)?_c('mobile-app-editor',{attrs:{"all-doc-fields":_vm.allDocFields,"close-editor":_vm.closeMobileEditor,"name":_vm.name}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-hdr"},[_c('i',{staticClass:"fa fa-ellipsis-v"}),_c('i',{staticClass:"fa fa-ellipsis-v"}),_vm._v("\n        Toolbox\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-tool float-left",attrs:{"data-field-type":"check"}},[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-tool float-left",attrs:{"data-field-type":"checkx"}},[_c('i',{staticClass:"fa fa-close"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-tool float-left",attrs:{"data-field-type":"checksq"}},[_c('i',{staticClass:"fa fa-square"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qDI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'account',
  data: function data() {
    return {};
  },

  watch: {},
  methods: {},
  components: {}
});

/***/ }),

/***/ "r1n9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s47I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account"},[_c('h3',[_vm._v("Account")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t+vV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tDjX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_NumberFormat__ = __webpack_require__("IzlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_DateFormat__ = __webpack_require__("e8Kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_FontOption__ = __webpack_require__("Fcb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_DocFieldType__ = __webpack_require__("xzgH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedDocField', 'dragRestriction', 'onFormatChanged', 'onFontChanged'],
  name: 'doc-builder',
  data: function data() {
    return {
      DateFormat: __WEBPACK_IMPORTED_MODULE_1__models_DateFormat__["a" /* default */],
      NumberFormat: __WEBPACK_IMPORTED_MODULE_0__models_NumberFormat__["a" /* default */],
      FontOption: __WEBPACK_IMPORTED_MODULE_2__models_FontOption__["a" /* default */],
      DocFieldType: __WEBPACK_IMPORTED_MODULE_3__models_DocFieldType__["a" /* default */]
    };
  },

  components: {},
  computed: {},
  watch: {},
  methods: {

    /*
     * Selected number or date format changed
     */
    onChangeFormat: function onChangeFormat() {
      if (this.onFormatChanged) {
        this.onFormatChanged();
      }
    },

    /*
     * Selected doc field font changed
     */
    onChangeFont: function onChangeFont() {
      if (this.onFontChanged) {
        this.onFontChanged();
      }
    }
  }
});

/***/ }),

/***/ "tGCc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uK6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__("qDI4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03435983_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__("s47I");
function injectStyle (ssrContext) {
  __webpack_require__("UN7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03435983"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03435983_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var appNavWidth = 40;
var appNavMaximizedWidth = 140;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isNavMaximized: false,
      appNavWidth: appNavWidth
    };
  },
  methods: {
    toggleNav: function toggleNav() {
      this.isNavMaximized = !this.isNavMaximized;
      if (this.isNavMaximized) {
        this.appNavWidth = appNavWidth;
      } else {
        this.appNavWidth = appNavMaximizedWidth;
      }
    }
  }
});

/***/ }),

/***/ "xZUn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"snapLine",class:_vm.classes,style:(_vm.style),attrs:{"title":_vm.title}},[_c('i',{class:_vm.snapLine.isVertical ? 'fa fa-caret-down' : 'fa fa-caret-right'})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xqBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"docFieldEl",staticClass:"doc-field",class:_vm.docField.isSelected ? 'selected' : '',style:(_vm.style),attrs:{"data-field-type":_vm.docField.type,"title":_vm.title},on:{"click":_vm.onClick}},[(_vm.docField.type === 'check')?_c('i',{staticClass:"fa fa-check"}):_vm._e(),_vm._v(" "),(_vm.docField.type === 'checkx')?_c('i',{staticClass:"fa fa-close"}):_vm._e(),_vm._v(" "),(_vm.docField.type === 'checksq')?_c('i',{staticClass:"fa fa-square"}):_c('span',{staticClass:"doc-field-text"},[_vm._v(_vm._s(_vm.docField.text))]),_vm._v(" \n  "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){_vm.$emit('delete-doc-field')}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xzgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  check: 'check',
  checksq: 'checksq',
  checkx: 'checkx',
  date: 'date',
  signature: 'signature',
  number: 'number',
  phone: 'phone',
  text: 'text'
}));

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.241ea317ce1c15159eca.js